// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Invitations-answer-box[data-v-5af7ab09]{width:500px;margin:auto;border:1px solid #ccc;padding:20px;margin-top:50px;margin-bottom:50px;text-align:center}h2[data-v-5af7ab09]{margin-top:30px;font-size:20px}@media only screen and (max-width:1000px){.Invitations-answer-box[data-v-5af7ab09]{width:calc(100% - 42px)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
